import menuIconOption from 'scoreboard/components/bootslide/menu-icon-option'
import ShapePicker from './config/shape-picker'
import i18n from 'scoreboard/components/i18n'
import ShapeModel from './shape-model'
import _ from 'lodash'
import {
	SHAPE_COLOR_TYPE, SHAPE_OPACITY,
	SHAPE_TEXT_ROTATION, SHAPE_TEXT_ROTATION_AUTO,
	SHAPE_TEXT_TYPE, DEFAULT_SHAPE_COLOR, SHAPE_SPECIFIC_COLOR
} from './shape-widget-properties'
import { SPECIFIC_COLOR } from './shape-color-type'
import { LINEAR } from './shape-fill-type'
import { NONE } from './shape-text-type'
import createWob from '../create-wob'
import defaultShapeDimensions from './default-shape-dimensions'
/**
 * Creates a menu item and submenu for adding a generic shape widget to a
 * dashboard. The submenu in this case is shape selection, since no domain
 * object is selected for the data source.
 *
 * @param {Object} addWidgetMenu - the bootslide menu for adding widgets
 */
function createShapeWidgetMenu (addWidgetMenu) {
	addWidgetMenu.setMaxHeight = true
	return {
		label: i18n.get('admin.import.performanceChartNode.shape'),
		content: menuIconOption('add-widget-shape',
			'admin.import.performanceChartNode.shape'),
		contentEndpoint: () => {
			let v = new ShapePicker({
				onSelectShape: shape => {
					createShapeWidget({ addWidgetMenu, shape })
				}
			})

			addWidgetMenu.childViews.push(v)
			return v.render().el
		}
	}
}

function createShapeWidget ({ addWidgetMenu, shape }) {
	let { properties, wobAttributes } = getWidgetPropertiesAndWobAttributes(shape)

	var widget = new ShapeModel(
		{ properties },
		{ section: addWidgetMenu.model.get('section') })

	createWob(addWidgetMenu.canvas, widget,
		{
			fetchData: false,
			wobAttributes
		},
		addWidgetMenu)
}

function getWidgetPropertiesAndWobAttributes (shape) {
	let wobAttributes = _.extend(
		_.pick(ShapeModel.prototype.containerDefaults, 'width', 'height'),
		defaultShapeDimensions[shape],
		DEFAULT_WOB_ATTRIBUTES)

	let properties = _.extend({},
		DEFAULT_WIDGET_PROPERTIES,
		{
			shape,
			shapeHeight: wobAttributes.height
		})

	return { properties, wobAttributes }
}

const DEFAULT_WIDGET_PROPERTIES = {
	type: 'shape',
	fill: LINEAR,
	showAbbreviatedNumbers: true,
	drilldownSection: 'default',
	[SHAPE_COLOR_TYPE]: SPECIFIC_COLOR,
	[SHAPE_SPECIFIC_COLOR]: DEFAULT_SHAPE_COLOR,
	[SHAPE_TEXT_TYPE]: NONE,
	[SHAPE_TEXT_ROTATION]: SHAPE_TEXT_ROTATION_AUTO,
	[SHAPE_OPACITY]: 100,
	background: NONE,
	fontSize: '13', // default from SB2
	outsideFontSize: '14', // from .legend styling in widgets.scss before it was configurable
	// since we default to 'none' for background, the shapeHeight will match
	// the wob height
	shapeHeight: ShapeModel.prototype.containerDefaults.height
}

const DEFAULT_WOB_ATTRIBUTES = {
	outlineWidth: '2px',
	outlineColor: 'auto'
}



export default createShapeWidgetMenu
export {
	DEFAULT_WOB_ATTRIBUTES,
	DEFAULT_WIDGET_PROPERTIES,
	getWidgetPropertiesAndWobAttributes
}

createShapeWidgetMenu.__filename__ = 'dashboards/widgets/shape/create-shape-widget-menu.js'
